/**
 * 签名工具类
 * 用于生成API请求签名
 */
 
import CryptoJS from 'crypto-js';

// 签名密钥（需与后端保持一致）
const SECRET_KEY = 'warzoneSignKey20240515';

/**
 * 生成API请求签名
 * @param {Object} params - 请求参数对象
 * @returns {String} - 加密后的签名
 */
export function generateSignature(params) {
  // 1. 添加时间戳
  const timestamp = Date.now();
  const signParams = { ...params, timestamp };
  
  // 2. 按键名字母顺序排序并拼接成字符串
  const sortedKeys = Object.keys(signParams).sort();
  let signStr = '';
  
  sortedKeys.forEach(key => {
    signStr += `${key}=${signParams[key]}&`;
  });
  
  // 3. 去掉最后的&并拼接密钥
  signStr = signStr.substring(0, signStr.length - 1) + SECRET_KEY;
  
  // 4. 使用MD5加密生成签名
  const sign = CryptoJS.MD5(signStr).toString();
  
  // 5. 将时间戳和签名添加到原参数中
  return {
    ...params,
    timestamp,
    sign
  };
}

/**
 * 为API请求参数生成签名
 * @param {Object} params - 原始请求参数
 * @returns {Object} - 添加了签名的请求参数
 */
export function signRequest(params) {
  return generateSignature(params);
} 